var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25,
    fill: "white",
    stroke: "#000064",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6598 16L26.0159 22.978L30.372 16H35.8251L29.1002 25.9176L36 36H30.4992L26.0159 28.8846L21.5326 36H16L22.9157 25.9176L16.1749 16H21.6598Z",
    fill: "#000064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNormal);
export default __webpack_public_path__ + "static/media/close-normal.136ecc3e6d08277d670a22841916f843.svg";
export { ForwardRef as ReactComponent };